import React from "react";
import Layout from "../components/Layout";
import "../css/App.css";

//import Feed from "../components/Feed";

export default function Bio() {
  //const posts = data.allMarkdownRemark.nodes;
  return (
    <Layout>
      <section className="bio">
        <p className="bio__text--main">
          Fernando González-Criado Leyra{" "}
          <span className="bio__text--secondary">
            (Santiago de Compostela, 1 de Abril del 2000)
          </span>
          , conocido profesionalmente como Fernando Leyra, en honor a su
          bisabuelo{" "}
          <a
            href="https://gl.wikipedia.org/wiki/Xos%C3%A9_Leyra"
            className="bio__text--link"
          >
            José Leyra Domínguez
          </a>
          , es un actor, fotógrafo y creativo español.
        </p>
        <p className="bio__text--main">
          Leyra comenzó su carrera como actor de la mano de su gran maestro
          Marcos Grande Pazos, en{" "}
          <a
            href="http://www.escoladeteatropabulo.com"
            className="bio__text--link"
          >
            Pábulo Teatro
          </a>{" "}
          en 2013. Paralelamente participó en producciones teatrales de
          compañías como Cuarta Parede{" "}
          <span className="bio__text--secondary">(Compostela Actúa)</span>,
          Tantometén{" "}
          <span className="bio__text--secondary">(Gustavo Garcia Dieste)</span>{" "}
          y Compañía Pábulo.
        </p>
        <p className="bio__text--main">
          Con 17 años fue elegido para protagonizar el largometraje{" "}
          <a
            href="https://www.lavozdegalicia.es/noticia/santiago/2019/08/31/vuelve-instituto-rodar-pelicula-contra-bullying/0003_201908S31C8991.htm"
            className="bio__text--link"
          >
            "No Todos Los Veranos Tienen Que Ser Azules"
          </a>
          , que cesó su producción por problemas con la dirección sin terminarse
          de rodar.
        </p>
        <p className="bio__text--main">
          En 2018 se muda a Madrid para estudiar Bellas Artes en la Universidad
          Complutense de Madrid. Participando activamente en el panorama
          cultural y artístico de la Universidad, dirigiendo talleres como
          <a
            href="https://ucm.es/agroecologia/taller-sinergias-taller-de-expresion-corporal-12-marzo-2021"
            className="bio__text--link"
          >
            {' "Sinergias"'}
          </a>{" "}
          para personas con discapacidad, actuando en la Semana de la Diversidad
          y formando parte del grupo de teatro musical universitario Cant-Arte.
          Un par de años después comenzó la diplomatura profesional en la
          <a
            href="https://www.escuelainternacionaldelgesto.com"
            className="bio__text--link"
          >
            {" Escuela Internacional del Gesto "}
          </a>
          de la mano de David Trueba.
        </p>
        <p className="bio__text--main">
          Fue Director de Fotografía de la revista
          <a href="https://www.coolturize.com" className="bio__text--link">
            {" Coolturize "}
          </a>
          durante su primer año de lanzamiento. Destacando su trabajo artístico,
          en el área de la fotografía de moda y el retrato, con diversas
          exposiciones por el territorio nacional, fanzines y encargos de
          diseñadores emergentes.
        </p>
        <p className="bio__text--main">
          Su debut, que parecía no llegar desde su primera película, apareció en
          el verano de 2021. Cuando de vuelta en su ciudad natal, después de
          rodar "5 Minutos Mas" en Extremadura, el director mexicano{" "}
          <a
            href="https://www.imdb.com/name/nm2774964/"
            className="bio__text--link"
          >
            Juan Carlos Blanco
          </a>{" "}
          lo llamó para coprotagonizar su largometraje internacional{" "}
          <a
            href="https://www.elcorreogallego.es/santiago/novia-suelta-por-el-casco-historico-DE8732306"
            className="bio__text--link"
          >
            "Mi Vestido de Novia"
          </a>
          , película iberomexicana que contó con el apoyo de la Xunta de Galicia
          y que se rodó en gallego y castellano simultáneamente.
        </p>
      </section>
    </Layout>
  );
}
